//主页面
const index = () => import(/* webpackChunkName:'grounp' */ '@/components/home.vue');

//出库明细详情
const inStockList = () =>
  import(/* webpackChunkName:'grounp' */ '@/pages/productionCenter/inStock/list.vue');

const productionRouter = {
  path: '/production',
  component: index,
  children: [
    {
      path: 'inStockList',
      name: 'inStockList',
      component: inStockList,
      meta: {
        keepAlive: true,
        title: '成品入库明细',
      },
    },
    // {
    //   path: 'rawDataAdd',
    //   name: 'rawDataAdd',
    //   component: rawDataAdd,
    //   meta: {
    //     keepAlive: true,
    //     title: '成品出库新增'
    //   }
    // }
  ],
};
export default productionRouter;
